import { network } from 'services/network';

export const createActivityCodeAlias = (params) => {
    return network.post('api/bo/createActivityCodeAlias', params).then((response) => response.data);
};
